import { render, staticRenderFns } from "./crm-dashboard.vue?vue&type=template&id=07c057cc&scoped=true&"
import script from "./crm-dashboard.vue?vue&type=script&lang=js&"
export * from "./crm-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./crm-dashboard.vue?vue&type=style&index=0&id=07c057cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c057cc",
  null
  
)

export default component.exports